import { UrlApi } from "../../../../../services/apirest";

export const getCountPendingReceipt = async (cliente) => {
  const response = await fetch(
    `${UrlApi}/ctacte/recibos/countPendientes/${cliente.id}/${cliente.id_negocio_cliente}`,
  );

  if (!response.ok)
    throw new Error(
      "Ocurrio un error al obtener la cantidad de recibos pendientes",
    );

  return await response.json();
};
